module.exports = __webpack_public_path__ + "main/assets/public/player-controls/skip-backwards-icon.80fa9a95b1f4d7cb.svg";